module.exports = __webpack_public_path__ + "static/media/inpatient_claims_hor.e1e91209.png";